import { Component, Input } from '@angular/core';

import { FilterService } from '@progress/kendo-angular-grid';
import { ListFilterBaseRow } from './listfilter-base-row';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { NgClass } from '@angular/common';

@Component({
    selector: 'nova-dropdown-filter-row',
    template: ` <kendo-dropdownlist
        [data]="data"
        [textField]="textField"
        [valueField]="valueField"
        [defaultItem]="defaultItem"
        [valuePrimitive]="true"
        [value]="selectedValue"
        (valueChange)="onChange($event)"
        [popupSettings]="popupSettings"
        [ngClass]="uniqueFilterClass">
    </kendo-dropdownlist>`,
    standalone: true,
    imports: [DropDownListModule, NgClass]
})
export class DropDownFilterRowComponent extends ListFilterBaseRow {
    @Input() defaultItemText = 'Select Item...';
    @Input() uniqueFilterClass: string;
    supportsMultipleValues = false;

    constructor(filterService: FilterService) {
        super(filterService);
    }

    public get defaultItem(): any {
        return {
            [this.textField]: this.defaultItemText,
            [this.valueField]: null
        };
    }
}
